// automatically generated by the FlatBuffers compiler, do not modify

/* eslint-disable @typescript-eslint/no-unused-vars, @typescript-eslint/no-explicit-any, @typescript-eslint/no-non-null-assertion */

/**
 * Which file of a bundle a position refers to.
 */
export enum SourceFile {
  None = 0,
  Main = 1,
  Include = 2,
  Controller = 3,
  EventsXml = 4,
  Builtin = 5,
}
